export default __webpack_public_path__ + "static/media/star.716a1366.png";